import React, { Component } from 'react';
import Request from '../Request';
import { IndexLink } from 'react-router';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nomeMunicipio: ''
      , siglaEstado: ''
    };
  }

  componentDidMount() {
    Request.getParametros(['municipio.nome', 'estado.sigla'], (param) => {
      if (param['municipio.nome']) {
        this.setState({ nomeMunicipio: param['municipio.nome'] });
      }
      if (param['estado.sigla']) {
        this.setState({ siglaEstado: param['estado.sigla'] });
      }
    });
  }

  renderTitulo() {
    return `${this.state.nomeMunicipio} - ${this.state.siglaEstado}`;
  }
  
  render() {
    const tituloHeaderStyle = {
      color: '#FFFFFF'
      , fontSize: '1.5em'
      , lineHeight: '50px'
    };

    const tituloImgStyle = {
      marginLeft: '5px'
      , marginRight: '10px'
    };

    return (
      <header id="header" className="main-header">
        <IndexLink to="/" className="logo">
          <span className="logo-mini"><b>S</b></span>
          <span className="logo-lg"><b>Sapitur</b> Sistemas </span>
        </IndexLink>
        <nav className="navbar navbar-static-top">
          <a className="sidebar-toggle" data-toggle="offcanvas" role="button">
            <span className="sr-only">Alternar navegação</span>
          </a>
          <span className="hidden-xs" style={tituloHeaderStyle}>
            <img src={Request.getUrlBrasao()} alt="Brasão Prefeitura" width="40px" height="40px" style={tituloImgStyle} />
            {this.renderTitulo()}
          </span>
        </nav>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/modulos/layout/Header.js